export default __webpack_public_path__ + "static/media/Materiality_Policy_and_related_information.eb30da20.pdf";